import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Cool Lawns totally transformed our backyard. The paver patio they built is incredible and they finished ahead of schedule. Highly recommend.',
  author: 'Sarah K.',
  location: 'Denton'
}, {
  quote: "Best lawn crew we've ever used. Super communicative, fair pricing, and they actually show up when they say they will.",
  author: 'Derek M.',
  location: 'Argyle'
}, {
  quote: 'We got quotes from three companies. Cool Lawns was the most reasonable and did the best work by far. Our front yard has never looked this good.',
  author: 'Lisa T.',
  location: 'Corinth'
}];
export function Testimonials() {
  return <section className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-130">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-131">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-132">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-4 inline-block relative" data-id="element-133">
            What Our Neighbors Are Saying
            <span className="absolute -bottom-2 left-1/4 right-1/4 h-1 bg-brand rounded-full" data-id="element-134"></span>
          </h2>
        </div>

        {/* Mobile: Swipeable Carousel, Desktop: Grid */}
        <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide lg:grid lg:grid-cols-3 gap-6 pb-8 -mx-6 px-6 lg:mx-0 lg:px-0 lg:overflow-visible lg:pb-0" data-id="element-135">
          {testimonials.map((testimonial, index) => <div key={index} className="snap-center shrink-0 w-[85vw] sm:w-[400px] lg:w-auto bg-gray-50 rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col" data-id="element-136">
              <div className="flex gap-1 mb-6" data-id="element-137">
                {[...Array(5)].map((_, i) => <Star key={i} className="text-yellow-400 fill-yellow-400 w-5 h-5" data-id="element-138" />)}
              </div>
              <blockquote className="text-gray-700 text-lg mb-8 flex-grow italic" data-id="element-139">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-4 mt-auto" data-id="element-140">
                <div className="w-12 h-12 bg-brand/10 rounded-full flex items-center justify-center text-brand font-bold text-xl" data-id="element-141">
                  {testimonial.author.charAt(0)}
                </div>
                <div data-id="element-142">
                  <p className="font-bold text-gray-900" data-id="element-143">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-500 text-sm" data-id="element-144">
                    {testimonial.location}, TX
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}